<template>
  <div v-if="isOpen" class="flex flex-col items-center justify-center fixed inset-0 z-50 ">
      <div  @click="closeModalOutSide" class="bg-bg-opacity-50 absolute inset-0"></div>

      <div class="bg-white flex flex-col rounded shadow-lg max-w-3/6 max-h-4/6 relative"
           :class="{'w-[90%] h-[90%]' : modalSettings?.fullSize, 'min-w-[800px] min-h-[600px] w-[50%] h-[50%]' : modalSettings?.halfSize}">

        <div v-if="childData?.title" class="flex text-center gap-2 p-2">
          <h1 class="flex-grow text-xl pl-[42px]">{{ childData?.title }}</h1>
          <button @click="changeScreen" class="bg-trader-gray p-1 px-2 "><i class="fa-solid fa-expand"></i></button>
          <button @click="closeModal" class="text-xl">&times;</button>
        </div>
        <div v-else class="flex justify-end px-2 py-1">
          <button @click="closeModal" data-ui="close-modal-x" class="text-2xl text-gray-600 hover:text-gray-800">&times;</button>
        </div>
        <div class="flex flex-grow overflow-hidden max-w-full max-h-full ">
          <component v-if="Object.keys(childData).length > 0" ref="child" :is="content" v-bind="childData"
                     :value="childData" @close-modal="closeModal" :title="''" class="flex-grow"></component>
        </div>
      </div>

  </div>
</template>


<script>
import {onBeforeUnmount, onMounted, reactive, toRefs} from 'vue';
import {eventBus} from "@/application/EventBus";
import ImageView from "@/components/Dialogs/ImageView.vue";
import SignalBus from "@/application/SignalBus";

export default {
  name: 'Modal',
  components: {
    ImageView
  },
  props: {
    content: {
      type: [String, Object],
      default: null
    },
    closeOutside: {
      type: Boolean,
      default: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    deleteModular: {
      type: Boolean,
      default: false
    },
  },
  setup() {
    const reactiveEventBus = reactive(eventBus);
    const {isOpen, content, closeModal, childData, modalSettings} = toRefs(reactiveEventBus);
    const handleKeydown = (e) => {
      if (e.key === 'Escape') {
        closeModal.value();
      }
    };

    onMounted(() => {
      window.addEventListener('keydown', handleKeydown);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', handleKeydown);
    });
    return {
      isOpen,
      content,
      closeModal,
      childData,
      modalSettings,
      property: false,
      currentHeadline: '',
      signal: '',
      handleKeydown,
    };
  },

  methods: {
     closeModalOutSide() {
     if (this.closeOutside) {
       this.closeModal();
     }
    },
    changeScreen() {
      this.modalSettings.fullSize = !this.modalSettings.fullSize;
      this.modalSettings.halfSize = !this.modalSettings.halfSize;
    }
  },
  created() {
    SignalBus.connect(this, 'close-modal', this.closeModal);
  },

};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 5px;
}

</style>
